import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0131 = React.lazy(() => import('./symbols/0131_arrow_back_undo'));
const Symbol0132 = React.lazy(() => import('./symbols/0132_arrow_back_left_'));
const Symbol0133 = React.lazy(() => import('./symbols/0133_arrow_right_next'));
const Symbol0134 = React.lazy(() => import('./symbols/0134_arrow_rotate_left_counter_clockwise'));
const Symbol0135 = React.lazy(() => import('./symbols/0135_arrow_rotate_right_clockwise'));
const Symbol0136 = React.lazy(() => import('./symbols/0136_rotation_lock'));
const Symbol0137 = React.lazy(() => import('./symbols/0137_zoom_expand_maximize_window'));
const Symbol0138 = React.lazy(() => import('./symbols/0138_expand_move_window_full_screen'));
const Symbol0139 = React.lazy(
  () => import('./symbols/0139_window_new_extern_full_screen_maximize')
);
const Symbol0140 = React.lazy(() => import('./symbols/0140_airplay_screen_sharing'));
const Symbol0141 = React.lazy(() => import('./symbols/0141_rotate_back_revert_undo'));
const Symbol0142 = React.lazy(() => import('./symbols/0142_rotate_sync'));
const Symbol0143 = React.lazy(() => import('./symbols/0143_rotate_clockwise'));
const Symbol0144 = React.lazy(() => import('./symbols/0144_arrows_play_shuffle'));
const Symbol0145 = React.lazy(() => import('./symbols/0145_arrows_play_repeat'));
const Symbol0146 = React.lazy(() => import('./symbols/0146_arrows_fast_forward'));
const Symbol0147 = React.lazy(() => import('./symbols/0147_arrows_divide_split'));
const Symbol0148 = React.lazy(() => import('./symbols/0148_arrows_directions_left_right'));
const Symbol0149 = React.lazy(() => import('./symbols/0149_arrows_curves'));
const Symbol0150 = React.lazy(() => import('./symbols/0150_resize_left_right'));
const Symbol0151 = React.lazy(() => import('./symbols/0151_plus_add_new'));
const Symbol0152 = React.lazy(() => import('./symbols/0152_minus_delete_remove'));
const Symbol0153 = React.lazy(() => import('./symbols/0153_delete_exit_remove_close'));
const Symbol0154 = React.lazy(() => import('./symbols/0154_ok_successful_check'));
const Symbol0155 = React.lazy(() => import('./symbols/0155_delete_remove_exit_close_checkbox'));
const Symbol0156 = React.lazy(() => import('./symbols/0156_checkbox_ok_successful'));
const Symbol0157 = React.lazy(() => import('./symbols/0157_arrow_back_left'));
const Symbol0158 = React.lazy(() => import('./symbols/0158_arrow_next_right'));
const Symbol0159 = React.lazy(() => import('./symbols/0159_arrow_back_left'));
const Symbol0160 = React.lazy(() => import('./symbols/0160_arrow_next_right'));
const Symbol0161 = React.lazy(
  () => import('./symbols/0161_on_off_switch_toggle_settings_preferences')
);
const Symbol0162 = React.lazy(
  () => import('./symbols/0162_on_off_switch_toggle_settings_preferences')
);
const Symbol0163 = React.lazy(
  () => import('./symbols/0163_on_off_switch_toggle_settings_preferences')
);
const Symbol0164 = React.lazy(
  () => import('./symbols/0164_on_off_switch_toggle_settings_preferences')
);
const Symbol0165 = React.lazy(
  () => import('./symbols/0165_on_off_switch_toggle_settings_preferences')
);
const Symbol0166 = React.lazy(() => import('./symbols/0166_back_delete_backspace'));
const Symbol0167 = React.lazy(() => import('./symbols/0167_plus_minus'));
const Symbol0168 = React.lazy(() => import('./symbols/0168_check_ok_yes_no'));
const Symbol0169 = React.lazy(() => import('./symbols/0169_target_circles'));
const Symbol0170 = React.lazy(() => import('./symbols/0170_puzzle_modules_build'));
const Symbol0171 = React.lazy(() => import('./symbols/0171_filter_funnel'));
const Symbol0172 = React.lazy(() => import('./symbols/0172_structure_menu_submenu_navigation'));
const Symbol0173 = React.lazy(() => import('./symbols/0173_structure_menu_submenu_navigation'));
const Symbol0174 = React.lazy(() => import('./symbols/0174_archive_open_slide'));
const Symbol0175 = React.lazy(() => import('./symbols/0175_slideshow'));
const Symbol0176 = React.lazy(() => import('./symbols/0176_module_connection_plugin'));
const Symbol0177 = React.lazy(() => import('./symbols/0177_puzzle_module_connect'));
const Symbol0178 = React.lazy(() => import('./symbols/0178_add_more_layers_slides'));
const Symbol0179 = React.lazy(() => import('./symbols/0179_layers_slides'));
const Symbol0180 = React.lazy(() => import('./symbols/0180_www_website_address_url_browser'));
const Symbol0181 = React.lazy(() => import('./symbols/0181_dropdown_menu_select_option_form'));
const Symbol0182 = React.lazy(() => import('./symbols/0182_screen_ok_success'));
const Symbol0183 = React.lazy(() => import('./symbols/0183_screen_text'));
const Symbol0184 = React.lazy(() => import('./symbols/0184_screen_text_images_presentation'));
const Symbol0185 = React.lazy(() => import('./symbols/0185_screen_grid_images'));
const Symbol0186 = React.lazy(() => import('./symbols/0186_window_text_images'));
const Symbol0187 = React.lazy(() => import('./symbols/0187_window_graph_analytics'));
const Symbol0188 = React.lazy(() => import('./symbols/0188_window_text_msg_box'));
const Symbol0189 = React.lazy(
  () => import('./symbols/0189_window_alert_notification_warning_error')
);
const Symbol0190 = React.lazy(() => import('./symbols/0190_window_error_danger_stop'));
const Symbol0191 = React.lazy(() => import('./symbols/0191_window_application_cursor'));
const Symbol0192 = React.lazy(
  () => import('./symbols/0192_window_application_code_shell_terminal')
);
const Symbol0193 = React.lazy(
  () => import('./symbols/0193_window_application_settings_preferences')
);
const Symbol0194 = React.lazy(() => import('./symbols/0194_layout_columns_sidemenu'));
const Symbol0195 = React.lazy(() => import('./symbols/0195_layout_columns_three'));
const Symbol0196 = React.lazy(() => import('./symbols/0196_layout_columns_title'));
const Symbol0197 = React.lazy(() => import('./symbols/0197_layout_grid_view'));
const Symbol0198 = React.lazy(() => import('./symbols/0198_battery_charge_empty'));
const Symbol0199 = React.lazy(() => import('./symbols/0199_battery_charge_empty'));
const Symbol0200 = React.lazy(() => import('./symbols/0200_battery_charge_half_empty'));
const Symbol0201 = React.lazy(() => import('./symbols/0201_battery_charge_full'));
const Symbol0202 = React.lazy(() => import('./symbols/0202_battery_charge_full'));
const Symbol0203 = React.lazy(() => import('./symbols/0203_battery_charging_energy'));
const Symbol0204 = React.lazy(() => import('./symbols/0204_bullets_list_radiobuttons'));
const Symbol0205 = React.lazy(() => import('./symbols/0205_bullets_list'));
const Symbol0206 = React.lazy(() => import('./symbols/0206_list_checkbox_todo'));
const Symbol0207 = React.lazy(() => import('./symbols/0207_list_checkbox_todo_done'));
const Symbol0208 = React.lazy(() => import('./symbols/0208_grid_view'));
const Symbol0209 = React.lazy(() => import('./symbols/0209_radiobuttons_bullets_lines'));
const Symbol0210 = React.lazy(() => import('./symbols/0210_checkboxes_lines_check'));

export interface IProps {}

const Gui: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0131_arrow_back_undo" symbol={<Symbol0131 />} />
      <LazySymbol id="0132_arrow_back_left_" symbol={<Symbol0132 />} />
      <LazySymbol id="0133_arrow_right_next" symbol={<Symbol0133 />} />
      <LazySymbol id="0134_arrow_rotate_left_counter_clockwise" symbol={<Symbol0134 />} />
      <LazySymbol id="0135_arrow_rotate_right_clockwise" symbol={<Symbol0135 />} />
      <LazySymbol id="0136_rotation_lock" symbol={<Symbol0136 />} />
      <LazySymbol id="0137_zoom_expand_maximize_window" symbol={<Symbol0137 />} />
      <LazySymbol id="0138_expand_move_window_full_screen" symbol={<Symbol0138 />} />
      <LazySymbol id="0139_window_new_extern_full_screen_maximize" symbol={<Symbol0139 />} />
      <LazySymbol id="0140_airplay_screen_sharing" symbol={<Symbol0140 />} />
      <LazySymbol id="0141_rotate_back_revert_undo" symbol={<Symbol0141 />} />
      <LazySymbol id="0142_rotate_sync" symbol={<Symbol0142 />} />
      <LazySymbol id="0143_rotate_clockwise" symbol={<Symbol0143 />} />
      <LazySymbol id="0144_arrows_play_shuffle" symbol={<Symbol0144 />} />
      <LazySymbol id="0145_arrows_play_repeat" symbol={<Symbol0145 />} />
      <LazySymbol id="0146_arrows_fast_forward" symbol={<Symbol0146 />} />
      <LazySymbol id="0147_arrows_divide_split" symbol={<Symbol0147 />} />
      <LazySymbol id="0148_arrows_directions_left_right" symbol={<Symbol0148 />} />
      <LazySymbol id="0149_arrows_curves" symbol={<Symbol0149 />} />
      <LazySymbol id="0150_resize_left_right" symbol={<Symbol0150 />} />
      <LazySymbol id="0151_plus_add_new" symbol={<Symbol0151 />} />
      <LazySymbol id="0152_minus_delete_remove" symbol={<Symbol0152 />} />
      <LazySymbol id="0153_delete_exit_remove_close" symbol={<Symbol0153 />} />
      <LazySymbol id="0154_ok_successful_check" symbol={<Symbol0154 />} />
      <LazySymbol id="0155_delete_remove_exit_close_checkbox" symbol={<Symbol0155 />} />
      <LazySymbol id="0156_checkbox_ok_successful" symbol={<Symbol0156 />} />
      <LazySymbol id="0157_arrow_back_left" symbol={<Symbol0157 />} />
      <LazySymbol id="0158_arrow_next_right" symbol={<Symbol0158 />} />
      <LazySymbol id="0159_arrow_back_left" symbol={<Symbol0159 />} />
      <LazySymbol id="0160_arrow_next_right" symbol={<Symbol0160 />} />
      <LazySymbol id="0161_on_off_switch_toggle_settings_preferences" symbol={<Symbol0161 />} />
      <LazySymbol id="0162_on_off_switch_toggle_settings_preferences" symbol={<Symbol0162 />} />
      <LazySymbol id="0163_on_off_switch_toggle_settings_preferences" symbol={<Symbol0163 />} />
      <LazySymbol id="0164_on_off_switch_toggle_settings_preferences" symbol={<Symbol0164 />} />
      <LazySymbol id="0165_on_off_switch_toggle_settings_preferences" symbol={<Symbol0165 />} />
      <LazySymbol id="0166_back_delete_backspace" symbol={<Symbol0166 />} />
      <LazySymbol id="0167_plus_minus" symbol={<Symbol0167 />} />
      <LazySymbol id="0168_check_ok_yes_no" symbol={<Symbol0168 />} />
      <LazySymbol id="0169_target_circles" symbol={<Symbol0169 />} />
      <LazySymbol id="0170_puzzle_modules_build" symbol={<Symbol0170 />} />
      <LazySymbol id="0171_filter_funnel" symbol={<Symbol0171 />} />
      <LazySymbol id="0172_structure_menu_submenu_navigation" symbol={<Symbol0172 />} />
      <LazySymbol id="0173_structure_menu_submenu_navigation" symbol={<Symbol0173 />} />
      <LazySymbol id="0174_archive_open_slide" symbol={<Symbol0174 />} />
      <LazySymbol id="0175_slideshow" symbol={<Symbol0175 />} />
      <LazySymbol id="0176_module_connection_plugin" symbol={<Symbol0176 />} />
      <LazySymbol id="0177_puzzle_module_connect" symbol={<Symbol0177 />} />
      <LazySymbol id="0178_add_more_layers_slides" symbol={<Symbol0178 />} />
      <LazySymbol id="0179_layers_slides" symbol={<Symbol0179 />} />
      <LazySymbol id="0180_www_website_address_url_browser" symbol={<Symbol0180 />} />
      <LazySymbol id="0181_dropdown_menu_select_option_form" symbol={<Symbol0181 />} />
      <LazySymbol id="0182_screen_ok_success" symbol={<Symbol0182 />} />
      <LazySymbol id="0183_screen_text" symbol={<Symbol0183 />} />
      <LazySymbol id="0184_screen_text_images_presentation" symbol={<Symbol0184 />} />
      <LazySymbol id="0185_screen_grid_images" symbol={<Symbol0185 />} />
      <LazySymbol id="0186_window_text_images" symbol={<Symbol0186 />} />
      <LazySymbol id="0187_window_graph_analytics" symbol={<Symbol0187 />} />
      <LazySymbol id="0188_window_text_msg_box" symbol={<Symbol0188 />} />
      <LazySymbol id="0189_window_alert_notification_warning_error" symbol={<Symbol0189 />} />
      <LazySymbol id="0190_window_error_danger_stop" symbol={<Symbol0190 />} />
      <LazySymbol id="0191_window_application_cursor" symbol={<Symbol0191 />} />
      <LazySymbol id="0192_window_application_code_shell_terminal" symbol={<Symbol0192 />} />
      <LazySymbol id="0193_window_application_settings_preferences" symbol={<Symbol0193 />} />
      <LazySymbol id="0194_layout_columns_sidemenu" symbol={<Symbol0194 />} />
      <LazySymbol id="0195_layout_columns_three" symbol={<Symbol0195 />} />
      <LazySymbol id="0196_layout_columns_title" symbol={<Symbol0196 />} />
      <LazySymbol id="0197_layout_grid_view" symbol={<Symbol0197 />} />
      <LazySymbol id="0198_battery_charge_empty" symbol={<Symbol0198 />} />
      <LazySymbol id="0199_battery_charge_empty" symbol={<Symbol0199 />} />
      <LazySymbol id="0200_battery_charge_half_empty" symbol={<Symbol0200 />} />
      <LazySymbol id="0201_battery_charge_full" symbol={<Symbol0201 />} />
      <LazySymbol id="0202_battery_charge_full" symbol={<Symbol0202 />} />
      <LazySymbol id="0203_battery_charging_energy" symbol={<Symbol0203 />} />
      <LazySymbol id="0204_bullets_list_radiobuttons" symbol={<Symbol0204 />} />
      <LazySymbol id="0205_bullets_list" symbol={<Symbol0205 />} />
      <LazySymbol id="0206_list_checkbox_todo" symbol={<Symbol0206 />} />
      <LazySymbol id="0207_list_checkbox_todo_done" symbol={<Symbol0207 />} />
      <LazySymbol id="0208_grid_view" symbol={<Symbol0208 />} />
      <LazySymbol id="0209_radiobuttons_bullets_lines" symbol={<Symbol0209 />} />
      <LazySymbol id="0210_checkboxes_lines_check" symbol={<Symbol0210 />} />
    </>
  );
});

Gui.displayName = 'Gui';

export default Gui;
